// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__265QZ","cloudBackground":"SearchBar_cloudBackground__1QGA9","searchBarContainer":"SearchBar_searchBarContainer__Qb500"};